import PageHeader from 'components/pageHeader/PageHeader';
import styled from 'styled-components';
import mediaQuery from 'styles/mediaQuery';

export const PageHeaderStyled = styled(PageHeader)`
  display: flex;
  flex-direction: column;

  .actions-container {
    align-self: end;
    display: flex;
    flex-direction: row;
    gap: 15px;

    .search-field {
      margin-bottom: 0;

      > div {
        padding: 0;
      }

      input[role='combobox'] {
        width: 160px;
      }
    }

    ${mediaQuery.xs} {
      width: 100%;

      .search-field {
        flex: 1;

        input[role='combobox'] {
          width: 100%;
        }
      }
    }
  }

  .child-container {
    display: flex;
    flex-direction: column;
    margin-top: 15px;
  }
`;
